import LookalikeAudiencesTable from './LookalikeAudiencesTable.Container';

export default LookalikeAudiencesTable;
